module.exports = __webpack_public_path__ + "public/img/ptz-icon4.3d0c305d.svg";